export interface IApiDateFinderCount {
  MyDates?: number;
  TotalDates?: number;
  MatchDates?: number;
}

export default class DateFinderCount {
  myDates: number;
  totalDates: number;
  matchDates: number;

  constructor() {
    this.myDates = 0;
    this.totalDates = 0;
    this.matchDates = 0;
  }

  static mappingPropertyObject(object: IApiDateFinderCount): DateFinderCount {
    const newObject = new DateFinderCount();
    newObject.myDates = object.MyDates || 0;
    newObject.totalDates = object.TotalDates || 0;
    newObject.matchDates = object.MatchDates || 0;
    return newObject;
  }
}
